var chunkMapping = {
	"24": [
		924,
		9883,
		11312,
		14806,
		25676,
		28677,
		31791,
		35179,
		40213,
		44330,
		44905,
		48404,
		50519,
		51808,
		58534,
		61501,
		63366,
		78373,
		82354,
		89699,
		92115,
		93484,
		96827,
		97757
	],
	"3519": [
		63519
	],
	"8744": [
		77428,
		84411
	],
	"8918": [
		60587
	]
};
var idToExternalAndNameMapping = {
	"924": [
		"default",
		"./base/sync/topic",
		23392
	],
	"9883": [
		"default",
		"./base/model/api/projectApi",
		23392
	],
	"11312": [
		"default",
		"./view/components",
		23392
	],
	"14806": [
		"default",
		"./platform/forWorkbench",
		23392
	],
	"25676": [
		"default",
		"./base/utils",
		23392
	],
	"28677": [
		"default",
		"./base/model/types",
		23392
	],
	"31791": [
		"default",
		"./ai/progressive/components",
		23392
	],
	"35179": [
		"default",
		"./base/model/types/Formula",
		23392
	],
	"40213": [
		"default",
		"./metrics/private/biz-components",
		23392
	],
	"44330": [
		"default",
		"./base/biz-components",
		23392
	],
	"44905": [
		"default",
		"./ai/progressive/stores",
		23392
	],
	"48404": [
		"default",
		"./app/contract",
		451
	],
	"50519": [
		"default",
		"./base/biz-utils/tools",
		23392
	],
	"51808": [
		"default",
		"./v2",
		17749
	],
	"58534": [
		"default",
		"./base/model/api/userApi",
		23392
	],
	"60587": [
		"default",
		"./base/model/query/workObjectBrief/workObjectBriefQuery",
		23392
	],
	"61501": [
		"default",
		"./base/model/query/linkPreview",
		23392
	],
	"63366": [
		"default",
		"./base/monitors",
		23392
	],
	"63519": [
		"default",
		"./platform/error-center",
		23392
	],
	"77428": [
		"default",
		"./platform/progressive/stores",
		23392
	],
	"78373": [
		"default",
		"./base/biz-utils/store",
		23392
	],
	"82354": [
		"default",
		"./base/model/query/fg",
		23392
	],
	"84411": [
		"default",
		"./base/providers",
		23392
	],
	"89699": [
		"default",
		"./base/components",
		23392
	],
	"92115": [
		"default",
		"./base/model/query/projectInfo/projectInfoQuery",
		23392
	],
	"93484": [
		"default",
		"./base/model/query",
		23392
	],
	"96827": [
		"default",
		"./agent-ui/service",
		48127
	],
	"97757": [
		"default",
		"./app/service",
		451
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}